import {useState} from 'react';
import {Box, Button, Stack, Typography} from '@mui/material';
import {FormProvider, useForm} from 'react-hook-form';
import Identity from './steps/Identity';
import Contact from './steps/Contact';
import Address from './steps/Adress';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import * as React from "react";

const steps = ['Nom', 'Contact', 'Adresses'];

const SubscriptionStepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const methods = useForm();

  const handleNextStep = async () => {
      console.log('ato');
      const valid = await methods.trigger();
     //const valid = true;
      console.log(methods.getValues())
      console.log(methods.formState.errors);
      console.log(valid);
    if (valid && currentStep === steps.length) {
      // handle submit
        navigate('/registration', {state : methods.getValues()});
        console.log(currentStep);
    }
    valid && setCurrentStep(state => state + 1);
  };

  const handleBackStep = () => {
      if (currentStep - 1 > 0) {
          setCurrentStep(state => state - 1)
      }
  }

  return (
    <>
      <FormProvider {...methods}>
          {1 === currentStep && <Identity handleNextStep={handleNextStep} />}
          {2 === currentStep && <Contact handleNextStep={handleNextStep} handleBackStep={handleBackStep}/>}
          {3 === currentStep && <Address handleNextStep={handleNextStep} handleBackStep={handleBackStep}/>}
      </FormProvider>
      <Stack
        direction="row"
        justifyContent={"center"}
        style={{paddingTop: 20, height: 140}}>
        {steps.map((step, index) => (
          <Stack direction="row" key={index} >
            <Stack  className={'step_selector'} alignItems={'center'}>
              <Box
                className={ currentStep === index + 1 ? "step_selector_number_selected" : "step_selector_number"}
              >
                    <Typography variant={'h2'} marginTop={'7px'}>{index + 1}</Typography>
              </Box>
              <Typography variant={"subtitle3"} width={'max-content'} color={'white'} display={{xs : 'none' , md : 'block' , lg : 'block'}}>{step}</Typography>
            </Stack>
            {index + 1 != steps.length && (
              <Box width={{xs : '20px' , md : '100px' , lg : '100px'}}  className={"separator_step"} />
            )}
          </Stack>
        ))}
      </Stack>
      <Stack justifyContent={"center"} direction={"row"}>
          <Button
              className="buttonSubscription"
              startIcon={
                  <RemoveRedEyeIcon
                      role={'img'}
                      aria-label="Plus d'informations"
                      color={'black'}
                  />
              }
              onClick={() => navigate('/subscription-choice')}>
              <Typography variant={'subtitle3'} color={'white'}>
                  Plus d'informations
              </Typography>
          </Button>
      </Stack>

    </>
  );
};


export default SubscriptionStepForm;
